/**
 * Names of the supported set of custom icons.
 */
export const ABOUT = "about";
export const HELP = "help";
export const SLACK = "slack";
export const CHROMATIN_VIEW = "chromatin-view";
